<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-card class="box">
      <v-data-table :headers="headers" :items="salary_rule_offering_list" dense class="elevation-1 mytable"
        :search="search">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Salary Rule Master Offering</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <span style="width: 20px"> </span>
          <v-row dense>
            <v-col cols="12" sm="3" md="3">
              <!-- <v-btn
                color="success"
                outlined
                rounded
                v-if="salary_rule_offering_list.length != 0"
              >
                <download-excel
                  class="mr-2 pb-3 pt-2"
                  :data="salary_rule_offering_list"
                  :fields="table_fields"
                  worksheet="PayRoll_SalaryRuleMasterOffering"
                  name="PayRoll_SalaryRuleMasterOffering.xls"
                >
                  <v-icon dark>mdi-file-excel</v-icon> Export
                </download-excel>
              </v-btn> -->
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'SalaryRuleMasterOffering')"
                :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" v-on="on" small>Add Salary Rule Master Offering</v-btn>
              </template>
              <v-card>
                <v-form>
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete dense v-model="editedItem.salary_rule_master_list"
                            :items="salary_rule_master_list" item-text="display_name" item-value="id"
                            label="Select Salary Rule" persistent-hint return-object single-line
                            :disabled="editedIndex != -1"></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value1" persistent-hint label="Value 1"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value2" persistent-hint label="Value 2"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value3" persistent-hint label="Value 3"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value4" persistent-hint label="Value 4"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value5" persistent-hint label="Value 5"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value6" persistent-hint label="Value 6"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value7" persistent-hint label="Value 7"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value8" persistent-hint label="Value 8"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value9" persistent-hint label="Value 9"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="12" md="6">
                          <v-text-field v-model="editedItem.value10" persistent-hint label="Value 10"
                            :rules="[(v) => !!v || 'required']" rounded outlined dense type="number">
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" @click="save">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <!-- <template v-slot:item.isactive="{ item }">
          <v-switch
            v-model="item.isactive"
            inset
            color="success"
            @change="toggleGroup(item)"
          ></v-switch>
        </template> -->
        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    overlay: false,
    // extraBreadcrumbItems: [
    //   { text: "Salary Rule Master Offering", disabled: true, href: "" },

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    errorMsg: {
      id: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Sr. No.",
        align: "left",
        value: "srno",
      },
      {
        text: "Name",
        align: "left",
        value: "name",
      },
      {
        text: "Display Name",
        align: "left",
        value: "display_name",
      },
      {
        text: "Value 1",
        align: "left",
        value: "value1",
      },
      {
        text: "Value 2",
        align: "left",
        value: "value2",
      },
      {
        text: "Value 3",
        align: "left",
        value: "value3",
      },
      {
        text: "Value 4",
        align: "left",
        value: "value4",
      },
      {
        text: "Value 5",
        align: "left",
        value: "value5",
      },
      {
        text: "Value 6",
        align: "left",
        value: "value6",
      },
      {
        text: "Value 7",
        align: "left",
        value: "value7",
      },
      {
        text: "Value 8",
        align: "left",
        value: "value8",
      },
      {
        text: "Value 9",
        align: "left",
        value: "value9",
      },
      {
        text: "Value 10",
        align: "left",
        value: "value10",
      },
      //   {
      //     text: "Status",
      //     align: "left",
      //     sortable: false,
      //     value: "isactive",
      //   },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      "Sr. No.": "srno",
      Name: "name",
      "Display Name": "display_name",
      "Value 1": "value1",
      "Value 2": "value2",
      "Value 3": "value3",
      "Value 4": "value4",
      "Value 5": "value5",
      "Value 6": "value6",
      "Value 7": "value7",
      "Value 8": "value8",
      "Value 9": "value9",
      "Value 10": "value10",
    },
    salary_rule_master_list: [],
    salary_rule_offering_list: [],
    editedIndex: -1,
    editedItem: {
      salary_rule_master_list: "",
      id: 0,
      value1: -999999,
      value2: -999999,
      value3: -999999,
      value4: -999999,
      value5: -999999,
      value6: -999999,
      value7: -999999,
      value8: -999999,
      value9: -999999,
      value10: -999999,
      //   status: true,
    },
    defaultItem: {
      salary_rule_master_list: "",
      id: 0,
      value1: -999999,
      value2: -999999,
      value3: -999999,
      value4: -999999,
      value5: -999999,
      value6: -999999,
      value7: -999999,
      value8: -999999,
      value9: -999999,
      value10: -999999,
      //   status: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Salary Rule Master Offering"
        : "Edit Salary Rule Master Offering";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Sr. No.</th>
      <th>Name</th>
      <th>Display Name</th>
      <th>Value 1</th>
      <th>Value 2</th>
      <th>Value 3</th>
      <th>Value 4</th>
      <th>Value 5</th>
      <th>Value 6</th>
      <th>Value 7</th>
      <th>Value 8</th>
      <th>Value 9</th>
      <th>Value 10</th>
      <th>Actions</th>
      
    </tr>`;

  this.salary_rule_offering_list.forEach((item, index) => {
    tab_text += `
    <tr>
      <td>${index + 1}</td>
      <td>${item.name}</td>
      <td>${item.display_name}</td>
      <td>${item.value1}</td>
      <td>${item.value2}</td>
      <td>${item.value3}</td>
      <td>${item.value4}</td>
      <td>${item.value5}</td>
      <td>${item.value6}</td>
      <td>${item.value7}</td>
      <td>${item.value8}</td>
      <td>${item.value9}</td>
      <td>${item.value10}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    // toggleGroup(item) {
    //   const formData = {
    //     id: item.id,
    //     status: item.isactive,
    //   };
    //   axios
    //     .post("/Payroll/toggleSalaryRuleMasterOffering", formData)
    //     .then((res) => {
    //       if (res.data.status.code == "SUCCESS") {
    //         this.showSnackbar(
    //           "#4caf50",
    //           "Salary Rule Master Offering Status Changed..."
    //         );
    //       } else {
    //       }
    //     })
    //     .catch((error) => {
    //       this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
    //       window.console.log(error);
    //     });
    // },
    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/salaryRuleMasterOffering")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.salary_rule_master_list = res.data.srm_list;
            this.salary_rule_offering_list = res.data.srm_offerings_list;
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.salary_rule_offering_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        axios
          .post("/Payroll/editSalaryRuleMasterOffering", this.editedItem)
          .then((res) => {
            if (res.data.status == "YES") {
              Object.assign(
                this.salary_rule_offering_list[this.editedIndex],
                this.editedItem
              );
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Salary Rule Master Offering Updated Successfully..."
              ); // show snackbar on success
            } else if (res.data.status == "NO") {
              this.showSnackbar(
                "#b71c1c",
                "Salary Rule Master Offering Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      } else {
        // console.log("save api data");
        // console.log(this.editedItem);
        if (this.editedItem.salary_rule_master_list == "") {
          this.showSnackbar("#b71c1c", "Please select Salary Rule Master!");
          return;
        }
        axios
          .post("/Payroll/saveSalaryRuleMasterOffering", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              // this.salary_component_list.push(this.editedItem);
              this.onLoad();
              this.showSnackbar(
                "#4caf50",
                "Salary Rule Master Offering Added Successfully..."
              ); // show snackbar on success
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Salary Rule Master Offering Already Present!!!"
              ); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });

        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.salary_rule_master_list) {
        return true;
      } else {
        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>